import React, {useState, useEffect} from 'react'
import { withRouter } from 'react-router-dom'
import EditPersonView from './person-details-container'
import EditCompanyView from './company-details-container'
import {useDispatch, useSelector} from 'react-redux'
import { sendErrorNotification } from '../../../../universal/notifications/notifications'
import { ToastContainer } from 'react-toastify'
import { changeSingleClientModal, requestUpdateSingleClientData } from '../../../../../redux/actions/single-client'
import moment from 'moment'
import { TransparentButton, SolidButton } from '../../../../library/button'
import { Popup } from '../../../../library/popup'
import './style.scss'

const Index = props => {

	const dispatch = useDispatch()
	const activeClient = useSelector(state => state.singleClient.details)
	const modalState = useSelector(state => state.singleClient.showModals.editModal)
	const companyId = useSelector(state => state.activeCompany.activeCompany.id)
	const updateLoading = useSelector(state => state.singleClient.updateDetails.loading)
	const clientId = props.match.params.id

	const [companyObject, setCompanyObject] = useState({
		type: "company",
		logoUrl: null,
		general: {
			name: null,
			organizationNumber: null,
			industry: null,
			employees: null,
			parentCompany: {
				id: null,
				infoUrl: null,
				name: null,
				organizationNumber: null
			},
			established: null,
			shareCapital: null,
			roles: [],
			shareholders: []
		},
		financials: {
			creditRating: {
				date: null, 
				description: null, 
				rating: null
			},
		},
		address: {
			street: null,
			postalCode: null,
			city: null,
			coordinates: null,
			county: null,
			municipality: null,
			region: null
		},
		contact: {
			phone: null,
			email: null,
			website: null
		},
		social: {
			twitter: null,
			facebook: null
		},
	})
	
	const [personObject, setPersonObject] = useState({
		type: "person",
		logoUrl: null,
		general: {
			firstName: null,
			lastName: null
		},
		contact: {
			phone: null,
			email: null,
			website: null
		},
		social: {
			twitter: null,
			facebook: null
		},
		address: {
			street: null,
			postalCode: null,
			city: null,
		},
	})

	useEffect(() => {
		if(Object.keys(activeClient).length > 0){
			if(activeClient && activeClient.type === "person"){
				setPersonObject({
					general: activeClient.general ? activeClient.general:null, 
					address: activeClient.address ? activeClient.address:null, 
					contact: activeClient.contact ? activeClient.contact:null, 
					social: activeClient.social ? activeClient.social:null,
					financials: activeClient.financials ? activeClient.financials:null,
					type: activeClient.type ? activeClient.type:null
				})
			} else if(activeClient && activeClient.type === "company"){
				setCompanyObject({
					general: {
						employees: activeClient.general && activeClient.general.employees ? activeClient.general.employees:null,
						industry: activeClient.general && activeClient.general.industry ? activeClient.general.industry:null,
						parentCompany: {
							name: activeClient.general && activeClient.general.parentCompany && activeClient.general.parentCompany.name ? activeClient.general.parentCompany.name:null,
							infoUrl: activeClient.general && activeClient.general.parentCompany && activeClient.general.parentCompany.infoUrl ? activeClient.general.parentCompany.infoUrl:null,
							name: activeClient.general && activeClient.general.parentCompany && activeClient.general.parentCompany.name ? activeClient.general.parentCompany.name:null,
							organizationNumber: activeClient.general && activeClient.general.parentCompany && activeClient.general.parentCompany.organizationNumber ? activeClient.general.parentCompany.organizationNumber:null
						},
						shareCapital: activeClient.general && activeClient.general.shareCapital ? activeClient.general.shareCapital:null,
						shareholders: activeClient.general && activeClient.general.shareholders ? activeClient.general.shareholders:null,
						organizationNumber: activeClient.general && activeClient.general.organizationNumber ? activeClient.general.organizationNumber:null,
						established: activeClient.general && moment.unix(activeClient.general.established).format('YYYY-MM-DD') ? moment.unix(activeClient.general.established).format('YYYY-MM-DD'):null,
						roles: activeClient.general && activeClient.general.roles ? activeClient.general.roles:null,
						name: activeClient.general && activeClient.general.name ? activeClient.general.name:null
					}, 
					address: activeClient.address && activeClient.address ? activeClient.address:null, 
					contact: activeClient.contact && activeClient.contact ? activeClient.contact:null, 
					social: activeClient.social && activeClient.social ? activeClient.social:null,
					financials: activeClient.financials && activeClient.financials ? activeClient.financials:null,
					type: activeClient.type ? activeClient.type:null
				})
			}
		}
	}, [activeClient])

	const handleClose = () => {
		dispatch(changeSingleClientModal({editModal: false}))
	}


	const clickUpdateClient = () => {
		if(activeClient.type === "company"){
			if(companyObject.general.name && companyObject.general.industry){
				dispatch(requestUpdateSingleClientData({client: companyObject, companyId: companyId, clientId: clientId}))
			} else {
				sendErrorNotification("Du må fylle inn et navn og bransje.")
			}
		} else if(activeClient.type === "person"){
			if(personObject.general.firstName && personObject.general.lastName){
				dispatch(requestUpdateSingleClientData({client: personObject, companyId: companyId, clientId: clientId}))
			} else {
				sendErrorNotification("Du må fylle inn fornavn og etternavn.")
			}
		}
	}

	return(
		<Popup
			onClose={handleClose}
			show={modalState} 
			title="Rediger kunde"
			buttons={[
				<TransparentButton title="Avbryt" type="button" data-dismiss="modal" onClick={() => handleClose()} />,
				<SolidButton title={updateLoading ? "Oppdaterer..":"Oppdater"} icon={updateLoading ? <i className="fas fa-circle-notch fa-spin"></i>:<i className="fas fa-sync"></i>} onClick={() => clickUpdateClient()} type="button"/>
			]}
		>
			<div className="edit-client-content-container">
				{activeClient && activeClient.type === "person" ? <EditPersonView personObject={personObject} setPersonObject={setPersonObject}/>:<EditCompanyView companyObject={companyObject} setCompanyObject={setCompanyObject}/>}
			</div>
			<ToastContainer/>
		</Popup>
	)

}

export default withRouter(Index)